<!--================================
=            TIMEGROUPS            =
=================================-->
<template>
    <!-- WIDGETS CARDS -->
    <v-container >
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Time Picker</div>
            </base-header>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Colors time

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around">
                            <v-time-picker v-model="e4" color="green lighten-1"></v-time-picker>
                            <v-time-picker v-model="e4" color="green lighten-1" header-color="primary">
                            </v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Disabled

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around" align="center">
                            <v-time-picker v-model="picker" disabled></v-time-picker>
                            <v-time-picker v-model="picker" :landscape="$vuetify.breakpoint.smAndUp" disabled>
                            </v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <!-- WIDGETS  -->
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Read-only

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around" align="center">
                            <v-time-picker v-model="picker" readonly></v-time-picker>
                            <v-time-picker v-model="picker" :landscape="$vuetify.breakpoint.smAndUp" readonly>
                            </v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <!-- WIDGETS  -->
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">24h format

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around">
                            <v-col class="lg-offset8" md="12" lg="4">
                                <v-time-picker v-model="e7" format="24hr"></v-time-picker>
                            </v-col>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Allowed times

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around">
                            <v-time-picker v-model="time" :allowed-hours="allowedHours"
                                :allowed-minutes="allowedMinutes" class="mt-4" format="24hr" scrollable min="9:30"
                                max="22:15"></v-time-picker>
                            <v-time-picker v-model="timeStep" :allowed-minutes="allowedStep" class="mt-4" format="24hr">
                            </v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Setting picker width

                    </div>
                    <div slot="card-body">
                        <v-row align="stretch" class="pa-5">
                            <v-col align-self="center">
                                <v-time-picker v-model="time" type="month" width="290" class="mt-4">
                                </v-time-picker>
                            </v-col>
                            <v-time-picker v-model="time" :landscape="$vuetify.breakpoint.mdAndUp" class="mt-4"
                                full-width type="month"></v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <!-- WIDGETS  -->
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">AM/PM switch in title

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around" align="center" class="pa-5">
                            <v-time-picker v-model="picker" ampm-in-title></v-time-picker>
                            <v-time-picker v-model="picker" :landscape="$vuetify.breakpoint.smAndUp" ampm-in-title>
                            </v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <!-- WIDGETS  -->
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">No title

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around">
                            <v-time-picker v-model="picker" no-title></v-time-picker>
                            <v-time-picker v-model="picker" :landscape="$vuetify.breakpoint.smAndUp" no-title>
                            </v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">With seconds

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around" align="center">
                            <v-time-picker v-model="picker" use-seconds></v-time-picker>
                            <v-time-picker v-model="picker" :landscape="$vuetify.breakpoint.smAndUp" use-seconds>
                            </v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Scrollable

                    </div>
                    <div slot="card-body">
                        <v-row justify="space-around" align="center">
                            <v-time-picker v-model="picker" scrollable></v-time-picker>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <!-- WIDGETS  -->
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Scrollable

                    </div>
                    <div slot="card-body">
                        <v-row class="pa-5">
                            <v-col cols="11" sm="5">
                                <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                    :return-value.sync="time" transition="scale-transition" offset-y max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="time" label="Picker in menu" prepend-icon="access_time"
                                            readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-time-picker v-if="menu2" v-model="time" full-width
                                        @click:minute="$refs.menu.save(time)"></v-time-picker>
                                </v-menu>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="11" sm="5">
                                <v-dialog ref="dialog" v-model="modal2" :return-value.sync="time" persistent
                                    width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="time" label="Picker in dialog" prepend-icon="access_time"
                                            readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-time-picker v-if="modal2" v-model="time" full-width>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modal2 = false">Cancel</v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(time)">OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <!-- WIDGETS  -->
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Range

                    </div>
                    <div slot="card-body">
                        <div class="pa-5">
                            <h1>Plan your event:</h1>
                            <v-row justify="space-around" align="center">
                                <v-col style="width: 290px; flex: 0 1 auto;">
                                    <h2>Start:</h2>
                                    <v-time-picker v-model="start" :max="end"></v-time-picker>
                                </v-col>
                                <v-col style="width: 290px; flex: 0 1 auto;">
                                    <h2>End:</h2>
                                    <v-time-picker v-model="end" :min="start"></v-time-picker>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </base-card>
            </v-col>
        </v-row>

    </v-container>

</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,BaseHeader
    },
        data() {
            return {
                e4: null,
                start: null,
                e7: null,
                end: null,
                start: null,
                end: null,
                picker: null,
                time: '11:15',
                timeStep: '10:10',
            }
        },
        methods: {
            allowedHours: v => v % 2,
            allowedMinutes: v => v >= 10 && v <= 50,
            allowedStep: m => m % 10 === 0,
        },
    };
</script>

<!--====  End of TIMEGROUPS  ====-->
